import React, {Fragment} from 'react';
import {postData} from '../../../utils/request';
import {get, set} from "../../../utils/dotutils";
import isEqual from 'lodash-es/isEqual';
import Select from "../Select";
import TextInput from "../TextInput";
import {loadComponentById} from "../../../utils/components";
import Button from "../Button";
import {debounce} from "lodash-es";

let pickpackpoints = null;

class PickPackPointControl extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            pickpackpoints: pickpackpoints,
            pickpackpoint: props.value.pickpackpoint || null,
            linkContact: this.props.linkContact
        };
        this.loadContact = debounce((partner_id) => {
            this.loadContactRequest && this.loadContactRequest.abort();
            this.loadContactRequest = loadComponentById("partner", partner_id, ["name", "email", "telnum"]);
            this.loadContactRequest.then((customer) => {
                this.setFieldValue("contact", customer.name);
                this.setFieldValue("email", customer.email);
                this.setFieldValue("telnum", customer.telnum);
            });
        }, 300);
    }

    componentDidMount() {
        if (!this.state.pickpackpoints) {
            this.initLayoutData();
        } else {
            this.setLayoutValues(this.state);
        }
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        if (!isEqual(this.props.value.pickpackpoint, prevProps.value.pickpackpoint)) {
            this.setState({
                pickpackpoint: this.props.value.pickpackpoint || null
            })
        }
        if (this.state.linkContact !== prevState.linkContact) {
            this.initValues();
        } else if (!isEqual(this.props.client, prevProps.client)) {
            this.initValues();
        }
    }

    initValues = () => {
        if (this.getProps('').disabled) return;
        if (this.props.autoFill !== false && this.state.linkContact !== false) {
            this.loadContact && this.loadContact.cancel();
            const partner_id = this.props.client.values.customer instanceof Object ? this.props.client.values.customer.partner_id : this.props.client.values.customer;
            if (partner_id) {
                this.loadContact(partner_id);
            }
        }
    }

    componentWillUnmount() {
        this.lastrequest && this.lastrequest.abort();
    }

    initLayoutData = () => {
        this.setState({isLoading: true}, () => {
            this.lastrequest && this.lastrequest.abort();
            this.lastrequest = postData({action: "pickpackpoint.getPickPackPoints", resptype: "json"});
            this.lastrequest.then((response) => {
                let state = {...this.state, isLoading: false};
                state.pickpackpoints = response.data;
                pickpackpoints = JSON.parse(JSON.stringify(response.data));
                this.setLayoutValues(state);
            });
            this.lastrequest.catch(() => {
                this.setState({isLoading: false});
            });
        });
    }

    setLayoutValues = (state) => {
        let selectedPickUpPoint = state.pickpackpoint || null;
        let selectedCounty = state.pickpackpointcounty || null;
        let selectedLocation = state.pickpackpointlocation || null;
        if (selectedPickUpPoint != null) {
            Object.keys(state.pickpackpoints).map((countyKey) => {
                Object.keys(state.pickpackpoints[countyKey] || {}).map((locationKey) => {
                    let stores = (state.pickpackpoints[countyKey] && state.pickpackpoints[countyKey][locationKey]) || [];
                    Object.keys(stores).map((key) => {
                        if (selectedPickUpPoint + "" === "" + key) {
                            selectedCounty = countyKey;
                            selectedLocation = locationKey;
                        }
                    });
                });
            });
        }
        state.pickpackpointcounty = selectedCounty;
        state.pickpackpointlocation = selectedLocation;
        this.setState(state);
    }

    setFieldValue = (field, value) => {
        this.setState({pickpackpoint: value}, () => {
            this.props.saveChanges && this.props.saveChanges(field, value);
        });
    }

    getProps = (name) => {
        let props = {};
        if (this.props.getFieldProps) {
            props = this.props.getFieldProps((this.props.name ? this.props.name + '.' : '') + name);
        }
        const disabled = this.props.disabled;//Array.isArray(this.props.disabled) ? this.props.disabled : [this.props.disabled];
        props.disabled = (!Array.isArray(disabled) && disabled) || (Array.isArray(disabled) && disabled.indexOf(name) !== -1);
        return props;
    }

    getFields = () => {
        const currentpickpackpoints = this.state.pickpackpoints || {};
        let selectedPickUpPoint = this.state.pickpackpoint || null;
        let selectedCounty = this.state.pickpackpointcounty || null;
        let selectedLocation = this.state.pickpackpointlocation || null;
        let county = this.state.pickpackpointcounty || null;
        let locate = this.state.pickpackpointlocation || null;
        let stores = (currentpickpackpoints[county] && currentpickpackpoints[county][locate]) || [];
        let counties = Object.keys(currentpickpackpoints).map((key) => {
            const v = {value: key, label: key};
            if (selectedCounty == v.value) {
                selectedCounty = v;
            }
            return v;
        });
        let locations = Object.keys(currentpickpackpoints[county] || {}).map((key) => {
            const v = {value: key, label: key};
            if (selectedLocation == v.value) {
                selectedLocation = v;
            }
            return v;
        });
        let exists = false;
        stores = Object.keys(stores).map((key) => {
            const v = {value: key, label: stores[key].title + '(' + stores[key].address + ')'};
            if (selectedPickUpPoint == v.value) {
                selectedPickUpPoint = v;
                exists = true;
            }
            return v;
        });

        const contactProps = this.getProps("contact");
        const emailProps = this.getProps("email");
        const telnumProps = this.getProps("telnum");
        const addressProps = this.getProps("address");

        return {
            ...this.props.fields,
            contact: <div className="col-md-12">
                <TextInput
                    {...contactProps}
                    name="contact"
                    required={true}
                    label="Címzett"
                    value={this.props.value && this.props.value.contact}
                    saveChanges={this.setFieldValue}
                    disabled={(this.props.autoFill !== false ? this.state.linkContact !== false : false) || contactProps.disabled}
                />
            </div>,
            email: <div className="col-md-12">
                <TextInput
                    {...emailProps}
                    name="email"
                    required={true}
                    label="Email"
                    value={this.props.value && this.props.value.email}
                    saveChanges={this.setFieldValue}
                    disabled={(this.props.autoFill !== false ? this.state.linkContact !== false : false) || emailProps.disabled}
                />
            </div>,
            telnum: <div className="col-md-12">
                <TextInput
                    {...telnumProps}
                    name="telnum"
                    required={true}
                    label="Telefon"
                    value={this.props.value && this.props.value.telnum}
                    saveChanges={this.setFieldValue}
                    disabled={(this.props.autoFill !== false ? this.state.linkContact !== false : false) || telnumProps.disabled}
                />
            </div>,
            autoInfo: <div className="col-md-12">
                <label className="control-label">&nbsp;</label>
                <Button
                    icon={{lib: "fas", name: this.state.linkContact !== false ? "link" : "unlink"}}
                    block={true}
                    color={this.state.linkContact !== false ? "primary" : "default"}
                    tooltip={"Autómatikus kitöltés " + (this.state.linkContact !== false ? "bekapcsolva" : "kikapcsolva")}
                    onClick={() => {
                        this.setState({linkContact: !(this.state.linkContact !== false)});
                    }}
                />
            </div>,
            postcode: <div key={2} className="col-sm-4">
                <Select
                    {...this.getProps("pickpackpoint")}
                    options={counties}
                    objectValue={false}
                    required={true}
                    storeType="local"
                    label="Város"
                    isLoading={this.state.isLoading}
                    saveChanges={(field, value) => this.setState({
                        pickpackpoint: null,
                        pickpackpointlocation: null,
                        pickpackpointcounty: value
                    })}
                    value={selectedCounty}
                    valueKey="value"
                    labelKey="label"
                    disabled={addressProps.disabled}
                />
            </div>,
            city: <div key={3} className="col-sm-4">
                <Select
                    {...this.getProps("pickpackpoint")}
                    options={locations}
                    objectValue={false}
                    required={true}
                    storeType="local"
                    label="Kerület vagy Település"
                    isLoading={this.state.isLoading}
                    saveChanges={(field, value) => this.setState({
                        pickpackpoint: null,
                        pickpackpointlocation: value
                    })}
                    value={selectedLocation}
                    valueKey="value"
                    labelKey="label"
                    disabled={addressProps.disabled}
                />
            </div>,
            address: <div key={4} className="col-sm-4">
                <Select
                    {...this.getProps("pickpackpoint")}
                    options={stores}
                    objectValue={false}
                    required={true}
                    storeType="local"
                    label="Átvevőpont"
                    isLoading={this.state.isLoading}
                    saveChanges={(field, value) => this.setFieldValue("pickpackpoint", value)}
                    value={selectedPickUpPoint}
                    valueKey="value"
                    labelKey="label"
                    error={!exists && !!selectedPickUpPoint ? "A kiválaszott átveteli pont jelenleg nem elérhető!" : null}
                    disabled={addressProps.disabled}
                />
            </div>
        };
    }

    getLayout = () => {
        const fields = this.getFields();
        return <Fragment>{fields.postcode}{fields.city}{fields.address}</Fragment>;
    }

    render() {
        return this.props.layout ? this.props.layout(this.getFields()) : this.getLayout();
    }

}

export default PickPackPointControl;